/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>
  <div class="tagCell cell-content flex-div HtmlEditorCell text-dian-dian w100b" :class="cellClass">
    <template v-if="shouldGroupWithoutReferenceColumn">
      <!--    如果向上合并 但没有参照列-->
      <template v-if="displayContent === preRecordColumnValue">
        <span :showValFlag="true"></span>
      </template>
      <template v-else>
        <cell-content-show :showValFlag="false" :cellContent="displayContent"/>
      </template>
    </template>

    <template v-else-if="shouldGroupWithReferenceColumn">
      <!--    如果向上合并 但存在参照列-->
      <cell-content-show-group :groupFlag="recordGroupFlag" :column="column" :cellContent="displayContent"/>
    </template>

    <template v-else-if="shouldShowWithReferenceColumn">
      <!--    如果不向上合并 但存在参照列-->
      <cell-content-show-group :groupFlag="recordGroupFlag" :column="column" :cellContent="displayContent"/>
    </template>

    <template v-else>
      <!--    如果不存在向上合并 则正常显示即可-->
      <cell-content-show :column="column" :extendClass="extendClassName" :cellContent="displayContent"/>
      <div class="tagDiv urgent-tag" v-if="showUrgentTag">&nbsp;急</div>
    </template>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xmInputCell",
});
</script>

<script lang="ts" setup>
import CellContentShow from '../../coms/cell-content-show.vue';
import CellContentShowGroup from '../../coms/cell-content-show-group.vue';
import {fixedFourNumber, fixedThreeNumber, fixedTwoNumber, fixedNumber, getNumberVal} from 'xmgoing-utils'
import {CtlComEnum} from "@/main-page/enums/ctlComEnum";
import {hasGridCellDisplayValue} from '@/utils/comUtils';

interface IProps {
  showColType: any,
  preRecord: any;
  record: any,
  column: any,
  index: any,
  cellContent: any,
}

const props = withDefaults(defineProps<IProps>(), {
  showColType: '',
  preRecord: () => ({}),
  record: () => ({}),
  column: () => ({}),
  index: () => ({}),
  cellContent: null,
})

const showVal = ref('');
const cellContent = toRef(props, 'cellContent');
const column = toRef(props, 'column');
const showColType = toRef(props, 'showColType');
const record = toRef(props, 'record');
const preRecord = toRef(props, 'preRecord');

// 计算显示内容，避免模板中重复计算
const displayContent = computed(() => {
  if (hasGridCellDisplayValue(showVal.value)) {
    return showVal.value;
  }
  return unref(cellContent);
});

// 初始化内容根据类型
const initContentByType = function () {
  const contentType = unref(showColType);
  const contentValue = unref(cellContent);
  
  switch(contentType) {
    case CtlComEnum.NUMBER:
      showVal.value = getNumberVal(contentValue);
      break;
    case CtlComEnum.NUMBER_2:
      showVal.value = fixedTwoNumber(contentValue);
      break;
    case CtlComEnum.NUMBER_3:
      showVal.value = fixedThreeNumber(contentValue);
      break;
    case CtlComEnum.NUMBER_4:
      showVal.value = fixedFourNumber(contentValue);
      break;
    case CtlComEnum.NUMBER_5:
      showVal.value = fixedNumber(contentValue, 5);
      break;
    default:
      showVal.value = '';
  }
}

initContentByType();
watch(cellContent, () => {
  initContentByType();
});

// 计算类名，避免内联样式
const cellClass = computed(() => {
  return {
    'flex-wrap-wrap': true,
    'cursor-pointer': true
  };
});

// 分组相关的计算属性
const shouldGroupWithoutReferenceColumn = computed(() => {
  return unref(column)?.hasGroupRow && !unref(column)?.groupCol && unref(preRecord);
});

const shouldGroupWithReferenceColumn = computed(() => {
  return unref(column)?.hasGroupRow && unref(column)?.groupCol;
});

const shouldShowWithReferenceColumn = computed(() => {
  return !unref(column)?.hasGroupRow && unref(column)?.groupCol;
});

const preRecordColumnValue = computed(() => {
  return unref(preRecord)?.[unref(column)?.propId];
});

const recordGroupFlag = computed(() => {
  return unref(record)?.groupFlag;
});

// 扩展类名计算
const extendClassName = computed(() => {
  if (unref(column)?.propId === 'orderNumber' && unref(record)?.priority === '加急') {
    return 'noW100b';
  }
  return 'w100b';
});

// 是否显示紧急标签
const showUrgentTag = computed(() => {
  return unref(column)?.propId === 'orderNumber' && unref(record)?.priority === '加急';
});
</script>

<style type="text/css" lang="less" scoped>
.flex-wrap-wrap {
  flex-wrap: wrap;
}

.cursor-pointer {
  cursor: pointer;
}

.urgent-tag {
  color: #F00;
}
</style>
